import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { App_FormBloc, App_FormCreatorJson, App_FormFieldMarqueurs, App_FormSketchFormDynamique, App_FormStep } from 'src/app/utils/interfaces';
import { Type_App_Validator, Type_FieldOrLabel } from 'src/app/utils/types';

@Component({
  selector: 'app-c-forms-dynamiques',
  templateUrl: './c-forms-dynamiques.component.html',
  styleUrls: ['./c-forms-dynamiques.component.scss'],
})
export class CFormsDynamiquesComponent implements OnInit {
  @Input({ required: true }) modeShow!: boolean;
  @Input() etatId?: number;

  @Input({ required: true }) formDynamiqueFormArray!: FormArray;
  @Input({ required: true }) formSketchFormDynamique!: App_FormSketchFormDynamique;

  @Input({ required: true }) blocName!: string;

  @Input({ required: true }) display!: App_FormCreatorJson; // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) context!: 'preparation' | 'edition';

  @Input({ required: true }) observeSourcesArr!: { formControl: FormControl; validator: Type_App_Validator; }[]; // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) step!: App_FormStep // TODO-pf? retirer + remplacer quand et si pertinent
  @Input({ required: true }) bloc!: App_FormBloc // TODO-pf? retirer + remplacer quand et si pertinent

  @Input({ required: true }) displayType: 'markerRow-fieldColum' | 'markerColumn-fieldRow' = 'markerRow-fieldColum'

  @Input({ required: true }) sourceMarqueurs: any;

  @Input({ required: false }) fieldMarqueurs: App_FormFieldMarqueurs | undefined;
  
  champs: Type_FieldOrLabel[] = [];

  fixedLegend: { label: string, description: string | undefined | null }[] = [];

  @Output() modifiedDescription = new EventEmitter<{
    label: string,
    description: string,
    index: number
  }>();

  constructor() { }

  ngOnInit() {
    const champs = this.formSketchFormDynamique?.champs;
    if (Array.isArray(champs)) {
      this.champs = champs
    }
    if (this.fieldMarqueurs) {
      this.defineFixedLegend(this.fieldMarqueurs);
    }
  }

  defineFixedLegend(fieldMarqueurs: App_FormFieldMarqueurs) {
    if (fieldMarqueurs) {
      const marqueursDatas = fieldMarqueurs.datas;
      if (marqueursDatas !== null && marqueursDatas !== undefined) {
        const fixedLegend = Object.entries(marqueursDatas).map(([key, entry]) => ({
          label: key,
          description: entry
        }));
        this.fixedLegend = fixedLegend;
      }
    }
  }

}
